import React from "react";
import ClientKitList from "../components/clients/client-kit/ClientKitList";

type Props = {};

const ClientKit = (props: Props) => {
  return (
    <div>
      <ClientKitList />
    </div>
  );
};

export default ClientKit;
